export default {
  WeTransfer_Site_Landing_Page_Overlay_WT_Plus_Button_Conversion:
    'https://dc.ads.linkedin.com/collect/?pid=1207732&conversionId=1057962&fmt=gif',
  WeTransfer_Site_Landing_Page_Overlay_WT_Free_send_file_Conversion:
    'https://dc.ads.linkedin.com/collect/?pid=1207732&conversionId=1057978&fmt=gif',
  WeTransfer_Site_Landing_Page_Overlay_WT_plus_send_file_Conversion:
    'https://dc.ads.linkedin.com/collect/?pid=1207732&conversionId=1057986&fmt=gif',
  WeTransfer_Got_Plus:
    'https://dc.ads.linkedin.com/collect/?pid=1207732&conversionId=1057994&fmt=gif',
  WeTransfer_Sign_Me_Up_Button_Conversion:
    'https://dc.ads.linkedin.com/collect/?pid=1207732&conversionId=1058018&fmt=gif',
  WeTransfer_Get_Plus_Conversion:
    'https://dc.ads.linkedin.com/collect/?pid=1207732&conversionId=1058002&fmt=gif',
  WeTransfer_More_About_Plus_Button_Conversion:
    'https://dc.ads.linkedin.com/collect/?pid=1207732&conversionId=1058010&fmt=gif',
  WT_Plus_Add_Payment_Conv:
    'https://dc.ads.linkedin.com/collect/?pid=1207732&conversionId=1058042&fmt=gif',
  Wetransfer_Plus_Complete_Order_Conv:
    'https://dc.ads.linkedin.com/collect/?pid=1207732&conversionId=1058034&fmt=gif',
  WeTransfer_Plus_Complete_Payment_Button_return_Conversion:
    'https://dc.ads.linkedin.com/collect/?pid=1207732&conversionId=1058050&fmt=gif',
  WT_Plus_go_to_Check_out_Conv:
    'https://dc.ads.linkedin.com/collect/?pid=1207732&conversionId=1058058&fmt=gif',
  WeTransfer_Account_Cancel_Subscription_Click:
    'https://dc.ads.linkedin.com/collect/?pid=1207732&conversionId=1058074&fmt=gif',
  WeTransfer_Account_Cancel_Subscription_Go_Ahead_Click:
    'https://dc.ads.linkedin.com/collect/?pid=1207732&conversionId=1058082&fmt=gif',
  WeTransfer_Account_Reactivate_Plus_Conversion:
    'https://dc.ads.linkedin.com/collect/?pid=1207732&conversionId=1058090&fmt=gif',
  WeTransfer_Reactivate_Plus_Go_Ahead_Conversion:
    'https://dc.ads.linkedin.com/collect/?pid=1207732&conversionId=1058098&fmt=gif',
};
